<div class="main-container-article text">
  <ng-container *ngIf="statu == '0'"> </ng-container>
  <ng-container *ngIf="statu == '2'">
    <div style="width: 100%; text-align: center; display: flex; justify-content: center; padding: 20px">
      <div style="width: 150px">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512"
          xml:space="preserve">
          <ellipse style="fill: #e04f5f" cx="256" cy="256" rx="256" ry="255.832" />

          <g transform="matrix(-0.7071 0.7071 -0.7071 -0.7071 77.26 32)">
            <rect x="3.98" y="-427.615" style="fill: #ffffff" width="55.992" height="285.672" />

            <rect x="-110.828" y="-312.815" style="fill: #ffffff" width="285.672" height="55.992" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <h2>{{ 'errorcode500' | t }}</h2>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="statu == '1'">
    <div style="width: 100%; text-align: center; display: flex; justify-content: center; padding: 20px">
      <div style="width: 100%">
        <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background: new 0 0 512 512; width: 150px"
          xml:space="preserve">
          <ellipse style="fill: #32bea6" cx="256" cy="256" rx="256" ry="255.832" />

          <polygon
            style="fill: #ffffff"
            points="235.472,392.08 114.432,297.784 148.848,253.616 223.176,311.52 345.848,134.504
	391.88,166.392 " />

          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </svg>
        <!-- <h2>{{ 'Payment_Successful_Desc' | t}}</h2> -->
        <p style="display: flex; font-size: 15px; font-weight: 600; justify-content: center">{{ 'Payment_Successful_Desc' | t }}</p>
      </div>
    </div>
  </ng-container>
</div>
